import styled from 'styled-components';

export const LayoutContainer = styled.div`
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    display: flex;
`;

export const LayoutBody = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    height: 100vh;
`;

export const LayoutBodyWrapper = styled.div`
    width: 100%;
    flex: 1;
    overflow-y: auto;
    background-color: #f5f8fa;
`;
//fafffe
//f5f8fa
